import { RouteObject } from "react-router-dom";
import { ServicePartnerTagList } from "@/pages/admin/servicepartner-tags/ServicePartnerTagList";
import { ServicePartnerTagCreate } from "@/pages/admin/servicepartner-tags/ServicePartnerTagCreate";
import { ServicePartnerTagEdit } from "@/pages/admin/servicepartner-tags/ServicePartnerTagEdit";
import { ServicePartnerTagDetail } from "@/pages/admin/servicepartner-tags/ServicePartnerTagDetail";

export const servicePartnersTagsRoutes: RouteObject[] = [
  {
    id: "tags-list",
    index: true,
    element: <ServicePartnerTagList />,
  },
  {
    id: "tags-create",
    path: "create",
    element: <ServicePartnerTagCreate />,
  },
  {
    id: "tags-edit",
    path: ":id/edit",
    element: <ServicePartnerTagEdit />,
  },
  {
    id: "tags-detail",
    path: ":id",
    element: <ServicePartnerTagDetail />,
  },
];
